import { render, staticRenderFns } from "./profile-table.vue?vue&type=template&id=596cb071&scoped=true"
import script from "./profile-table.vue?vue&type=script&lang=js"
export * from "./profile-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cb071",
  null
  
)

export default component.exports